import List from "list.js";
import "jquery-highlight";

(function (jQuery) {

    var options = {
        valueNames: [ 'item__title', 'item__description' ]
    };

    var listObj = new List('glossar', options);

    $('#search-field').on('keyup', function () {
        var searchString = $(this).val();
        $(".list").unhighlight();
        listObj.search(searchString);
        $(".list").highlight(searchString, {wordsOnly: false});
    });

})(jQuery);